import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20romantic%20modern%20interior%20scene%20with%20soft%20ambient%20lighting%20two%20elegant%20wine%20glasses%20on%20a%20cozy%20table%20abstract%20artistic%20bokeh%20background%20beige%20and%20warm%20amber%20tones%20editorial%20photography%20style%20high%20detail%20sophisticated%20and%20intimate%20mood%20luxurious%20yet%20minimalist%20atmosphere&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="约炮攻略 - 真实有效的约炮技巧与平台推荐"
          title="约炮攻略"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50"></div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 md:mb-6 leading-tight">
          约炮攻略
        </h1>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          真实有效的约炮技巧与平台推荐，帮你快速找到志同道合的伴侣，提升约炮成功率，让每一次邂逅都自然愉快、安全无忧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/yuepao-jiqiao"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line"></i>
            查看约炮技巧
          </Link>
          <Link
            to="/category/pingtai-tuijian"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-smartphone-line"></i>
            平台推荐
          </Link>
        </div>
      </div>
    </section>
  );
}